import { createFileRoute } from "@tanstack/react-router";

import { HubIndexPage, hubQuery } from "@/components/hubs/HubIndexPage";
import { hubIndexHead } from "@/lib/hub-seo";

const PATH = "/pubs";

export const Route = createFileRoute("/pubs/")({
  loader: ({ context }) => context.queryClient.ensureQueryData(hubQuery("pubs")),
  head: ({ loaderData }) =>
    hubIndexHead({
      path: PATH,
      locale: "en",
      loaderData,
      fallbackTitle: 'Pubs in Finland — beer halls and locals | what Finland',
      fallbackDescription: 'Finnish pubs and beer halls by region, with opening hours.',
      listName: 'Pubs in Finland',
    }),
  component: () => <HubIndexPage slug="pubs" locale="en" />,
});
